import { Disclosure, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

function decodeToken(token: string) {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
}

interface NavigationItem {
  name: string;
  href: string;
  className: string;
  onClick?: (e: React.MouseEvent) => void;
}

const handlePricingClick = (e: React.MouseEvent) => {
  e.preventDefault();
  const pricingSection = document.getElementById("pricing");
  if (pricingSection) {
    pricingSection.scrollIntoView({ behavior: "smooth" });
  }
};

const baseNavigation: NavigationItem[] = [
  // {
  //   name: "Pricing",
  //   href: "/#pricing",
  //   onClick: handlePricingClick,
  //   className:
  //     "text-white hover:bg-gray-700 rounded-md text-sm font-montserrat uppercase tracking-wider px-3 py-2",
  // },
];

const adminNavigation: NavigationItem = {
  name: "Admin",
  href: "/admin",
  className:
    "text-white hover:bg-gray-700 rounded-md text-sm font-montserrat uppercase tracking-wider px-3 py-2",
};

export default function Navbar() {
  const location = useLocation();
  const token = localStorage.getItem("token");

  // Always use dark styling
  const navContainerClasses = "bg-gray-900 absolute w-full top-0 z-[100] border-b border-gray-700";

  // Adjust hamburger mobile button styling
  const mobileButtonClass = "inline-flex items-center justify-center rounded-md bg-transparent px-3 py-2 text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-600";

  let isAdmin = false;
  if (token) {
    const userData = decodeToken(token);
    isAdmin = userData && userData.role === "admin";
  }

  const navigationItems: NavigationItem[] = [...baseNavigation];
  if (isAdmin) {
    navigationItems.push(adminNavigation);
  }

  const accountButton = {
    name: token ? "Dashboard" : "Sign In",
    href: token ? "/dashboard" : "/auth",
    className:
      "bg-indigo-600 text-white hover:bg-indigo-700 rounded-full text-sm font-montserrat uppercase tracking-wider px-3 py-2",
  };

  const navigation = [...navigationItems, accountButton];

  return (
    <Disclosure as="nav" className={navContainerClasses}>
      {({ open }) => (
        <>
          <div className="w-full px-12 sm:px-16 lg:px-24">
            <div className="relative flex h-24 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center lg:hidden">
                <Disclosure.Button className={mobileButtonClass}>
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>

              <div className="flex flex-1 items-center justify-center lg:items-stretch lg:justify-between">
                <div className="flex flex-shrink-0 items-center">
                  <Link to="/" className="flex items-center gap-4">
                    <img src={logo} alt="Logo" className="h-10 w-auto" />
                    <div className="flex items-center gap-3">
                      <div className="flex flex-col justify-center">
                        <span className="font-outfit font-bold text-xl leading-none text-white">
                          Swiftclear
                        </span>
                        <span className="font-arial font-light text-sm leading-none text-gray-300">
                          technologies
                        </span>
                      </div>
                      <span className="bg-indigo-600 text-white rounded text-xs font-montserrat uppercase tracking-wider px-2 py-1">
                        BETA
                      </span>
                    </div>
                  </Link>
                </div>



                <div className="hidden lg:ml-6 lg:flex lg:items-center lg:space-x-8 lg:mr-12">
                  {navigation.map((item: NavigationItem) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={item.onClick}
                      className={`${item.className}`}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <Transition
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Disclosure.Panel className="lg:hidden bg-gray-800 p-4 border-b border-gray-700">
              <div className="space-y-2">
                {navigation.map((item: NavigationItem) => (
                  <Disclosure.Button
                    key={item.name}
                    as={Link}
                    to={item.href}
                    onClick={item.onClick}
                    className="text-white hover:bg-gray-700 block rounded-md px-3 py-2 text-base font-arial uppercase tracking-wider"
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>
            </Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
